import Actions from '../../odata/actions';

const actions = new Actions('restaurantAdmin', 'restaurantAdmins');

export default actions;
